/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import Styles from "./supervisorDashboard.module.scss";
import { Badge, Card, Col, Collapse, Divider, Empty, Row } from "antd";
import Icon, { CaretUpFilled, CaretRightFilled } from "@ant-design/icons";
import {
  PriorityIcon,
  ToteIconGrey,
  TrolleyIconGrey,
} from "../../assets/icons/icons";
import { getTrolleyStatus } from "../../components/reusable/styles";
import { convertUTCToLocal } from "../../utils/timeUtils";
import ActivityLogs from "./activityLogs";

const LocationView = ({ d1, setDashboardView }: any) => {
  // state
  const [showTotes, setShowTotes] = useState({ show: false, id: null });
  const [logOpen, setLogOpen] = useState({ open: false, details: null });

  const getCardTitle = (locationName: string) => {
    switch (locationName) {
      case "Airlog Packing":
        return { name: "Airlog Packing", target: "1.5 hours" };

      case "Airlog Dispatch Dock":
        return { name: "Airlog Dispatch Dock", target: "1 hour" };

      case "FAL Proximity Store (L80)":
        return { name: "FAL Proximity Store (L80)", target: "2 hours" };

      case "FAL PoU":
        return { name: "FAL PoU", target: "3 hours" };

      case "Airlog Empty Holding":
        return { name: "Airlog Empty Holding", target: "6.5 hours" };

      default:
        return { name: locationName, target: "" };
    }
  };

  return (
    <Row gutter={10} className={Styles.rowWrapper}>
      {logOpen?.open && <ActivityLogs open={logOpen} setOpen={setLogOpen} />}
      {d1?.details &&
        d1?.details?.map((location: any, index: number) => {
          const uniqueKey = location?.location_id ?? `loc-${index}`;
          const hasItems = location?.totes?.length || location?.trolley?.length;
          const cardTitles = getCardTitle(location?.location_name);
          const handleFlowOpen = (value: string) => {
            localStorage?.setItem("flowFilter", value);
            localStorage?.setItem("dashboardTab", "Flow");
            setDashboardView("Flow");
          };

          return (
            <Col key={uniqueKey} flex="20%">
              <Card
                className="dashboardCards"
                title={
                  <div>
                    <div style={{ fontWeight: 600 }}>{cardTitles.name}</div>
                    {cardTitles.target && (
                      <div style={{ fontSize: 12, fontWeight: 400 }}>
                        ( Target Time: {cardTitles.target})
                      </div>
                    )}
                  </div>
                }
              >
                {hasItems ? (
                  <>
                    {location?.trolley?.map((trolley: any) => {
                      const trolleyId = trolley?.trolley_id;
                      const trolleySerial = trolley?.trolley_serial_id;
                      const isOpen =
                        showTotes?.show && showTotes?.id === trolleyId;

                      return (
                        <Collapse
                          ghost
                          activeKey={isOpen ? trolleyId : null}
                          style={{
                            background: trolley?.overdue
                              ? "#F6D1D1"
                              : isOpen
                              ? "#F5F5F5"
                              : "#e6f3f7",
                          }}
                          onChange={() => {
                            if (trolley?.totes?.length && !logOpen?.open) {
                              setShowTotes({
                                show:
                                  showTotes?.id === trolleyId
                                    ? !showTotes?.show
                                    : true,
                                id: trolleyId,
                              });
                            }
                          }}
                          className="trolleyCard"
                          expandIconPosition="end"
                          expandIcon={({ isActive }) =>
                            trolley?.totes?.length ? (
                              isActive ? (
                                <CaretUpFilled style={{ fontSize: 12 }} />
                              ) : (
                                <CaretRightFilled style={{ fontSize: 12 }} />
                              )
                            ) : (
                              false
                            )
                          }
                        >
                          <Collapse.Panel
                            key={trolleyId}
                            header={
                              <div>
                                <Row
                                  justify="space-between"
                                  align="middle"
                                  style={{ width: "100%" }}
                                >
                                  <Row align="middle">
                                    <Icon
                                      component={TrolleyIconGrey}
                                      onClick={() => {
                                        setLogOpen({
                                          open: true,
                                          details: trolley,
                                        });
                                      }}
                                    />
                                    <div
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: 6,
                                      }}
                                      className="toteValue"
                                      onClick={(e) => {
                                        e.stopPropagation(); // prevent collapse toggle
                                        handleFlowOpen(trolleySerial);
                                      }}
                                    >
                                      {trolleySerial}
                                    </div>
                                  </Row>

                                  <Row align="middle" gutter={10}>
                                    {(trolley?.priority === "HIGH" ||
                                      trolley?.priority === "High") && (
                                      <Col>
                                        <Icon component={PriorityIcon} />
                                      </Col>
                                    )}

                                    {trolley?.totes?.length > 0 && (
                                      <Col>
                                        <Badge
                                          count={trolley?.totes?.length}
                                          color="#0285AD"
                                          style={{
                                            borderRadius: 3,
                                            fontSize: "10px",
                                          }}
                                          size="small"
                                        />
                                      </Col>
                                    )}
                                  </Row>
                                </Row>
                                {trolley?.totes?.length > 0 && isOpen && (
                                  <>
                                    <Row
                                      justify="space-between"
                                      style={{ marginTop: "20px" }}
                                    >
                                      <Col>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            color: "#878787",
                                          }}
                                        >
                                          Status
                                        </div>
                                        <div
                                          style={{
                                            color: getTrolleyStatus(
                                              trolley?.trolley_status
                                            ),
                                            fontSize: "13px",
                                          }}
                                        >
                                          {trolley?.trolley_status}
                                        </div>
                                      </Col>
                                      <Col>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            color: "#878787",
                                          }}
                                        >
                                          Registered Date
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            color: "#000",
                                          }}
                                        >
                                          {convertUTCToLocal(
                                            trolley?.registered_on
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                    <Divider
                                      style={{
                                        borderColor: "#fff",
                                        margin: "10px 0 5px 0",
                                      }}
                                    />{" "}
                                  </>
                                )}
                              </div>
                            }
                          >
                            <div>
                              {trolley?.totes?.map((tote: any) => (
                                <Col span={24} key={tote?.tote_id}>
                                  <div className="insideTotes">
                                    <div>
                                      <Row gutter={5}>
                                        <Col>
                                          <Icon
                                            component={ToteIconGrey}
                                            onClick={() => {
                                              setLogOpen({
                                                open: true,
                                                details: tote,
                                              });
                                            }}
                                          />
                                        </Col>
                                        <Col style={{ fontSize: "12px" }}>
                                          Tote ID
                                        </Col>
                                      </Row>

                                      <Row
                                        align="middle"
                                        justify="space-between"
                                      >
                                        <Col>
                                          <div
                                            className="toteValue"
                                            onClick={() =>
                                              handleFlowOpen(
                                                tote?.tote_serial_id
                                              )
                                            }
                                            style={{ cursor: "pointer" }}
                                          >
                                            {tote?.tote_serial_id}
                                          </div>
                                        </Col>
                                        <Row gutter={10}>
                                          {/* {tote?.overdue && (
                                            <Col>
                                              <Tooltip title="Overdue to next location">
                                                <img
                                                  alt="overdue"
                                                  src={OverdueIcon}
                                                  height={18}
                                                />
                                              </Tooltip>
                                            </Col>
                                          )} */}

                                          {(tote?.priority === "HIGH" ||
                                            tote?.priority === "High") && (
                                            <Col>
                                              <Icon component={PriorityIcon} />
                                            </Col>
                                          )}
                                        </Row>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                              ))}
                            </div>
                          </Collapse.Panel>
                        </Collapse>
                      );
                    })}
                    {/* //fec5bb //fae1dd */}
                    {location?.totes?.map((tote: any) => (
                      <Card
                        key={tote?.tote_id}
                        className="toteCard"
                        style={{
                          height: "fit-content",
                          background: tote?.overdue ? "#FBE6E6" : "",
                          boxShadow: tote?.overdue
                            ? ""
                            : "0px 2px 8px 0px #00000014",
                          // border: "1px solid #EDEDED",
                        }}
                      >
                        <Row align="middle" justify="space-between">
                          <Row gutter={10} align="middle">
                            <Col>
                              <Icon
                                component={ToteIconGrey}
                                onClick={() => {
                                  setLogOpen({
                                    open: true,
                                    details: tote,
                                  });
                                }}
                              />
                            </Col>
                            <Col>
                              <div
                                style={{ cursor: "pointer" }}
                                className="toteValue"
                                onClick={() =>
                                  handleFlowOpen(tote?.tote_serial_no)
                                }
                              >
                                {tote?.tote_serial_no}
                              </div>
                            </Col>
                          </Row>
                          {/* 
                          {tote?.overdue && (
                            <Col>
                              <Tooltip title="Overdue to next location">
                                <img
                                  alt="overdue"
                                  src={OverdueIcon}
                                  height={18}
                                />
                              </Tooltip>
                            </Col>
                          )} */}

                          {(tote?.priority === "HIGH" ||
                            tote?.priority === "High") && (
                            <Col>
                              <Icon component={PriorityIcon} />
                            </Col>
                          )}
                        </Row>
                      </Card>
                    ))}
                  </>
                ) : (
                  <Row
                    justify="center"
                    align="middle"
                    style={{ height: "80%" }}
                  >
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </Row>
                )}
              </Card>
            </Col>
          );
        })}
    </Row>
  );
};

export default LocationView;
